import React from 'react';
import './../../Styles/Main/Main.scss'
import PagesWrapper from './../../UI/pagewrapper/PagesWrapper';
import MyButton from './../../UI/button/MyButton';
import { BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import { pagesRoutes } from './../../Constant/index'

function Main() {
   return (
      <div className='mainPage__wrapper'>
         <div className="mainPage__body">
            <div className="mainPage__title">
               <div className="mainPage__text">
                  Great bikes, easy rides!
               </div>
               <Link to={pagesRoutes[1].path}>
                  <div className="mainPage__button">
                     <MyButton
                        style={{ fontSize: '20px', fontWeight: 700 }}
                     >
                        Go to rent
                     </MyButton>
                  </div>
               </Link>
            </div>
            <div className="mainPage__back-image">
               <img src="./image/main-page.jpg" alt="" />
            </div>
         </div>
      </div>
   );
}
export default Main;

